import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ClientApp from './client/ClientApp';
import AdminApp from './admin/AdminApp';
import { useUserContext } from './UserContext'; 
import axiosInstance from './axiosInstance'; // keep if you use it here
import './App.css';
import Enter from './Enter';
import CreatorDashboard from './client/Pages/CreatorDashboard'; // adjust path if needed

const App = () => {
  const ProtectedRoute = ({ element, adminOnly }) => {
    const { user } = useUserContext();
    const location = useLocation();

    // Admin-only check
    if (adminOnly && user?.role !== 'admin') {
      return <Navigate to="/" replace />;
    }

    // Normal login check
    if (user) return element;

    // Special exception for creator-dashboard preview access
    const params = new URLSearchParams(location.search);
    const preview = params.get('preview') === 'true';
    const fromPricePredictor = location.state?.fromPricePredictor;

    if (
      location.pathname === '/creator-dashboard' &&
      preview &&
      fromPricePredictor
    ) {
      return element; // allow access without login
    }

    // Otherwise redirect to login
    return <Navigate to="/login-signup" replace />;
  };

  return (
    <Routes>
      {/* Admin routes */}
      <Route path="/admin/*" element={<ProtectedRoute element={<AdminApp />} adminOnly={true} />} />

      {/* Creator dashboard with preview exception */}
      <Route path="/creator-dashboard" element={<ProtectedRoute element={<CreatorDashboard />} />} />

      {/* Enter routes */}
      <Route path="/enter/:email/:link" element={<Enter />} />
      <Route path="/enter/*" element={<Enter />} />

      {/* All other client routes */}
      <Route path="/*" element={<ClientApp />} />
    </Routes>
  );
};

export default App;